const toNumber: (s: string) => number = (str: string) => {
    return parseInt(str.replace(/[^\d]/g, ''), 10);
};

const toFloat: (s: string) => number = (str: string) => {
    return parseFloat(str.replace(/[^\d.]/g, ''));
};

export {toNumber, toFloat};
